import { CommonModule } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { AppCommonModule } from 'src/app/common.module';
import { KanbanItemViewDialogComponent } from 'src/app/kanban/view/item/item-view.dialog';
import { RoomTicket } from 'src/app/models/ticket.model';
import { TranslateTicketPipe } from 'src/app/pipes/ticket-translate/ticket-translate.pipe';

@Component({
  selector: 'app-tickets-created',
  styleUrls: ['./tickets-created.component.scss'],
  templateUrl: './tickets-created.component.html',
  imports: [
    AppCommonModule,
    CommonModule,
    TranslateTicketPipe,
  ],
})
export class TicketsCreatedComponent {
  private modalCtrl = inject(ModalController);

  tickets = input.required<RoomTicket[]>();

  onTicket(ticket: RoomTicket) {
    this.modalCtrl.create({
      component: KanbanItemViewDialogComponent,
      componentProps: {
        ticket,
      },
    }).then((m) => {
      m.present();
    });
  }
}
